// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import {
//   Typography,
//   Container,
//   Box,
//   TextField,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Breadcrumbs,
//   Link as MUILink,
// } from "@mui/material";
// import axios from "../../axiosInstance";
// import { Link } from "react-router-dom";
// import { message } from "antd";
// import moment from "moment";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { useSelector, useDispatch } from "react-redux";
// import AddQuestions from "./AddQuestions";
// import { useNavigate } from "react-router-dom";
// import { getCourses } from "../../redux/actions/admin/courseAction";

// function CustomTabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// CustomTabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

// function TabPanel(index) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }

// export default function AddExamQuestion() {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { courses, loading, error } = useSelector((state) => state.courses);
//   const { user } = useSelector((state) => state.user);
//   const [value, setValue] = useState(0);

//   // Updated state variables
//   const [name, setName] = useState("");
//   const [subject, setSubject] = useState("");
//   const [examClass, setExamClass] = useState("");
//   const [duration, setDuration] = useState("");
//   const [totalMarks, setTotalMarks] = useState("");
//   const [passingMarks, setPassingMarks] = useState("");
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [startTime, setStartTime] = useState("");
//   const [endTime, setEndTime] = useState("");
//   const [negativeMarking, setNegativeMarking] = useState("");
//   const [publicExam, setPublicExam] = useState("");

//   const [questionCount, setQuestionCount] = useState(0);

//   const handleStartDateChange = (date) => {
//     setStartDate(date);
//   };

//   const handleEndDateChange = (date) => {
//     setEndDate(date);
//   };

//   const examStartDate = moment(startDate).format("DD/MM/YYYY");
//   const examEndDate = moment(endDate).format("DD/MM/YYYY");

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   // Fetch all institute courses
//   useEffect(() => {
//     dispatch(getCourses());
//   }, [dispatch]);

//   // Add Exam
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // Format times to HH:MM string format
//     // Format the times properly - extract only the time portion
//     let formattedStartTime = "";
//     let formattedEndTime = "";

//     if (startTime && startTime instanceof Date && !isNaN(startTime)) {
//       formattedStartTime = moment(startTime).format("HH:mm");
//     } else if (typeof startTime === "string" && startTime) {
//       formattedStartTime = startTime;
//     }

//     if (endTime && endTime instanceof Date && !isNaN(endTime)) {
//       formattedEndTime = moment(endTime).format("HH:mm");
//     } else if (typeof endTime === "string" && endTime) {
//       formattedEndTime = endTime;
//     }
//     const addExam = {
//       name,
//       subject,
//       class: examClass,
//       duration,
//       totalMarks,
//       passingMarks,
//       negativeMarking,
//       startDate: examStartDate,
//       endDate: examEndDate,
//       //     startTime,
//       // endTime,
//       startTime: formattedStartTime, // Send formatted time (e.g., "14:30")
//       endTime: formattedEndTime, // Send formatted time (e.g., "16:00")
//       publicExam,
//     };

//     console.log("Submitting Exam Data:", addExam); // Debugging log
//     try {
//       const { data } = await axios.post("api/v1/exam/add", addExam);
//       if (data.success === true) {
//         message.success(data.message);
//         localStorage.setItem("id", JSON.stringify(data?.data?._id));
//         // Clear form fields
//         setName("");
//         setSubject("");
//         setExamClass("");
//         setDuration("");
//         setTotalMarks("");
//         setPassingMarks("");
//         setStartDate(null);
//         setEndDate(null);
//         setStartTime(null); // Clear time as well
//         setEndTime(null); // Clear time as well
//         setNegativeMarking("");
//         setPublicExam("");
//         // Automatically switch to the correct tab after adding the exam
//         setValue(1);
//       } else {
//         message.error(data?.message);
//         console.error("Failed to add exam:", data);
//       }
//     } catch (error) {
//       message.error(error?.response?.data?.message, "Failed to add exam");
//       console.error("Failed to add exam:", error);
//     }
//   };

//   // Use The Navigate in Question List
//   const localStorageId = JSON.parse(localStorage.getItem("id"));

//   // check the question length
//   const getAllQuestionLength = async () => {
//     try {
//       // Check if localStorageId exists
//       if (!localStorageId) {
//         message.warning("No questions added yet. Please add questions first.");
//         return { success: false, count: 0 };
//       }
//       const response = await axios.get(`/api/v1/exam/${localStorageId}`);
//       const count = response?.data?.data?.questions?.length || 0;
//       setQuestionCount(count);
//       return { success: true, count };
//     } catch (error) {
//       message.error(
//         error?.response?.data?.message,
//         "Failed to fetch question count",
//       );
//       return { success: false, count: 0 };
//     }
//   };

//   useEffect(() => {
//     if (localStorageId) {
//       getAllQuestionLength();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [localStorageId]);

//   const handleShowQuestionList = async () => {
//     const { success, count } = await getAllQuestionLength();
//     if (!success) {
//       return; // Exit if there was an error
//     }
//     if (count === 0) {
//       message.warning("No questions added yet. Please add questions first.");
//     } else {
//       navigate(`/admin/edit/exam/${localStorageId}`);
//     }
//   };

//   return (
//     <>
//       <Box sx={{ width: "100%" }}>
//         <Typography
//           variant="h5"
//           align="center"
//           gutterBottom
//           sx={{
//             mb: 3,
//             fontFamily: "Poppins, sans-serif",
//             color: "#2C3E50",
//             letterSpacing: "2.5px",
//             lineHeight: 1.8,
//           }}
//         >
//           Add Exams And Questions
//         </Typography>
//         <Breadcrumbs
//           aria-label="breadcrumb"
//           sx={{
//             mb: 5,
//             backgroundColor: "#fff",
//             padding: "20px",
//             borderRadius: "12px",
//             boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//           }}
//         >
//           <MUILink
//             component={Link}
//             to="/"
//             sx={{ color: "inherit", textDecoration: "none" }}
//           >
//             Dashboard
//           </MUILink>
//           <MUILink
//             component={Link}
//             to="/admin/exams"
//             sx={{ color: "inherit", textDecoration: "none" }}
//           >
//             Exams
//           </MUILink>
//           <Typography sx={{ color: "primary.main" }}>
//             Add Exams And Questions
//           </Typography>
//         </Breadcrumbs>
//         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//           <Tabs
//             value={value}
//             onChange={handleChange}
//             aria-label="basic tabs example"
//           >
//             <Tab label="Add Exam" {...TabPanel(0)} />
//             <Tab label="Add Question" {...TabPanel(1)} />
//           </Tabs>
//         </Box>

//         {/* Add Exams */}
//         <CustomTabPanel value={value} index={0}>
//           <Typography
//             variant="h6"
//             sx={{
//               pb: 2,
//               pt: 3,
//               fontFamily: "Poppins, sans-serif",
//               color: "#555",
//               letterSpacing: "2.5px",
//               lineHeight: 1.8,
//             }}
//           >
//             Create a new Exam
//           </Typography>
//           <Container
//             onSubmit={handleSubmit}
//             component="form"
//             className="form_style border-style"
//             maxWidth
//           >
//             <Box sx={{ mb: 3 }}>
//               <FormControl fullWidth>
//                 <InputLabel id="public-exam-label">Public Exam</InputLabel>
//                 <Select
//                   labelId="public-exam-label"
//                   id="public-exam"
//                   value={publicExam}
//                   label="Public Exam"
//                   required
//                   onChange={(e) => setPublicExam(e.target.value)}
//                 >
//                   <MenuItem value="yes">Yes</MenuItem>
//                   <MenuItem value="no">No</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& .MuiInputBase-root": {
//                   color: "text.secondary",
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="name"
//               label="Exam Name *"
//               name="name"
//               InputLabelProps={{
//                 shrink: true,
//               }}
//               placeholder="Exam Name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               required
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& .MuiInputBase-root": {
//                   color: "text.secondary",
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="subject"
//               label="Subject *"
//               name="subject"
//               InputLabelProps={{
//                 shrink: true,
//               }}
//               placeholder="Subject"
//               value={subject}
//               onChange={(e) => setSubject(e.target.value)}
//               required
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& .MuiInputBase-root": {
//                   color: "text.secondary",
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="class"
//               label="Class *"
//               name="class"
//               InputLabelProps={{
//                 shrink: true,
//               }}
//               placeholder="Class"
//               value={examClass}
//               onChange={(e) => setExamClass(e.target.value)}
//               required
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& .MuiInputBase-root": {
//                   color: "text.secondary",
//                 },
//                 "& input[type='number']": {
//                   MozAppearance: "textfield",
//                   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
//                     {
//                       display: "none",
//                     },
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="duration"
//               label="Duration (mins) *"
//               name="duration"
//               type="number"
//               InputLabelProps={{
//                 shrink: true,
//               }}
//               placeholder="Duration (mins)"
//               value={duration}
//               onChange={(e) => setDuration(e.target.value)}
//               required
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& .MuiInputBase-root": {
//                   color: "text.secondary",
//                 },
//                 "& input[type='number']": {
//                   MozAppearance: "textfield",
//                   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
//                     {
//                       display: "none",
//                     },
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="totalMarks"
//               label="Total Marks *"
//               name="totalMarks"
//               type="number"
//               InputLabelProps={{
//                 shrink: true,
//               }}
//               placeholder="Total Marks"
//               value={totalMarks}
//               onChange={(e) => setTotalMarks(e.target.value)}
//               required
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& .MuiInputBase-root": {
//                   color: "text.secondary",
//                 },
//                 "& input[type='number']": {
//                   MozAppearance: "textfield",
//                   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
//                     {
//                       display: "none",
//                     },
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="passingMarks"
//               label="Passing Marks *"
//               name="passingMarks"
//               type="number"
//               InputLabelProps={{
//                 shrink: true,
//               }}
//               placeholder="Passing Marks"
//               value={passingMarks}
//               onChange={(e) => setPassingMarks(e.target.value)}
//               required
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& .MuiInputBase-root": {
//                   color: "text.secondary",
//                 },
//                 "& input[type='number']": {
//                   MozAppearance: "textfield",
//                   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
//                     {
//                       display: "none",
//                     },
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="negativeMarks"
//               label="Negative Marks (optional)"
//               name="negativeMarks"
//               type="number"
//               InputLabelProps={{
//                 shrink: true,
//               }}
//               placeholder="Negative Marks (optional)"
//               value={negativeMarking}
//               onChange={(e) => setNegativeMarking(e.target.value)}
//             />

//             {/* <Box style={{ display: "flex", justifyContent: "space-between" }} className="Date"> 
//             <Box style={{ display: "flex" }} className="Date">
//               <Box
//                 sx={{
//                   mb: 3,
//                 }}
//                 style={{ marginRight: "2%" }}
//               >
//                 <DatePicker
//                   showIcon
//                   toggleCalendarOnIconClick
//                   isClearable
//                   placeholderText="Start Date"
//                   selected={startDate}
//                   value={startDate}
//                   onChange={handleStartDateChange}
//                   minDate={new Date()}
//                   maxDate={endDate}
//                   required
//                 />
//               </Box>
//               <Box>
//                 <DatePicker
//                   required
//                   showIcon
//                   toggleCalendarOnIconClick
//                   isClearable
//                   placeholderText="End Date"
//                   selected={endDate}
//                   onChange={handleEndDateChange}
//                   value={endDate}
//                   minDate={startDate || new Date()}
//                 />
//               </Box>
//             </Box>

//             <Box>
//               <TextField
//                 type="time"
//                 label="Start Time"
//                 value={startTime}
//                 onChange={(e) => setStartTime(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 required
//               />
//             </Box>

//             <Box>
//               <TextField
//                 type="time"
//                 label="End Time"
//                 value={endTime}
//                 onChange={(e) => setEndTime(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 required
//               />
//             </Box>
// </Box> */}
//             <Typography
//               variant="h6"
//               sx={{
//                 pb: 1,
//                 mt: -2,
//                 fontFamily: "Poppins, sans-serif",
//                 color: "#555",
//                 letterSpacing: "2.5px",
//                 lineHeight: 1.8,
//                 fontSize: "16px",
//               }}
//             >
//               {" "}
//               Configure Exam Schedule{" "}
//             </Typography>
//             <Box
//               sx={{
//                 display: "grid",
//                 gridTemplateColumns: {
//                   xs: "1fr", // Mobile
//                   sm: "1fr 1fr", // Tablet
//                   md: "1fr 1fr 1fr 1fr", // Desktop
//                 },
//                 gap: 2,
//                 width: "60%",
//               }}
//             >
//               <DatePicker
//                 showIcon
//                 toggleCalendarOnIconClick
//                 isClearable
//                 placeholderText="Start Date"
//                 selected={startDate}
//                 onChange={handleStartDateChange}
//                 minDate={new Date()}
//                 maxDate={endDate}
//                 required
//                 // className="date-picker"
//               />

//               <DatePicker
//                 showIcon
//                 toggleCalendarOnIconClick
//                 isClearable
//                 placeholderText="End Date"
//                 selected={endDate}
//                 onChange={handleEndDateChange}
//                 minDate={startDate || new Date()}
//                 required
//                 // className="date-picker"
//               />

//               <TextField
//                 fullWidth
//                 type="time"
//                 label="Start Time"
//                 value={startTime}
//                 onChange={(e) => setStartTime(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 required
//               />

//               <TextField
//                 fullWidth
//                 type="time"
//                 label="End Time"
//                 value={endTime}
//                 onChange={(e) => setEndTime(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 required
//               />
//             </Box>

//               <Typography
//               variant="h6"
//               sx={{
//                 pb: 3,
//                 mb: -2,
//                 fontFamily: "Poppins, sans-serif",
//                 color: "#555",
//                 letterSpacing: "2.5px",
//                 lineHeight: 1.8,
//                 fontSize: "16px",
//               }}
//             >
//               {" "}
//               Configure Result Schedule{" "}
//             </Typography>
//             <Box
//               sx={{
//                 display: "grid",
//                 gridTemplateColumns: {
//                   xs: "1fr", // Mobile
//                   sm: "1fr 1fr", // Tablet
//                   md: "1fr 1fr 1fr 1fr", // Desktop
//                 },
//                 gap: 2,
//                 width: "60%",
//               }}
//             >
//               <DatePicker
//                 showIcon
//                 toggleCalendarOnIconClick
//                 isClearable
//                 placeholderText="Start Date "
//                 selected={startDate}
//                 onChange={handleStartDateChange}
//                 minDate={new Date()}
//                 maxDate={endDate}
//                 required
//                 // className="date-picker"
//               />
//                <TextField
//                 fullWidth
//                 type="time"
//                 label="Start Time"
//                 value={startTime}
//                 onChange={(e) => setStartTime(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 required
//               />
//               </Box>
//             <Button
//               variant="contained"
//               type="submit"
//               color="primary"
//               className="courses_desc"
//               sx={{
//                 mt: 3,
//                 borderRadius: "5px",
//                 textTransform: "none",
//                 fontFamily: "Poppins, sans-serif",
//                 letterSpacing: ".1rem",
//                 color: "white",
//               }}
//             >
//               Add Exam
//             </Button>
//           </Container>
//         </CustomTabPanel>

//         {/* Add Questions */}
//         <CustomTabPanel value={value} index={1}>
//           <Typography
//             variant="h6"
//             sx={{
//               pb: 2,
//               pt: 3,
//               fontFamily: "Poppins, sans-serif",
//               color: "#555",
//               letterSpacing: "2.5px",
//               lineHeight: 1.8,
//             }}
//           >
//             Add Question
//           </Typography>
//           <AddQuestions
//             vendor_Id={user?._id}
//             institute_Id={user?.instituteId}
//           />

//           <Button
//             variant="outlined"
//             onClick={handleShowQuestionList}
//             type="submit"
//             className="courses_desc"
//             sx={{
//               mt: 3,
//               borderRadius: "50px",
//               textTransform: "none",
//               fontFamily: "Poppins, sans-serif",
//               letterSpacing: ".1rem",
//             }}
//           >
//             Show Question List
//           </Button>
//         </CustomTabPanel>
//       </Box>
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Typography,
  Container,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Breadcrumbs,
  Link as MUILink,
  Alert
} from "@mui/material";
import axios from "../../axiosInstance";
import { Link } from "react-router-dom";
import { message } from "antd";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import AddQuestions from "./AddQuestions";
import { useNavigate } from "react-router-dom";
import { getCourses } from "../../redux/actions/admin/courseAction";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function TabPanel(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AddExamQuestion() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { courses, loading, error } = useSelector((state) => state.courses);
  const { user } = useSelector((state) => state.user);
  const [value, setValue] = useState(0);

  // Updated state variables
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [examClass, setExamClass] = useState("");
  const [duration, setDuration] = useState("");
  const [totalMarks, setTotalMarks] = useState("");
  const [passingMarks, setPassingMarks] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [negativeMarking, setNegativeMarking] = useState("");
  const [publicExam, setPublicExam] = useState("");
  
  // New state variables for result schedule
  const [resultDate, setResultDate] = useState(null);
  const [resultTime, setResultTime] = useState("");
  const [showResultSchedule, setShowResultSchedule] = useState(false);

  const [questionCount, setQuestionCount] = useState(0);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  
  // New function for result date change
  const handleResultDateChange = (date) => {
    setResultDate(date);
  };

  const examStartDate = moment(startDate).format("DD/MM/YYYY");
  const examEndDate = moment(endDate).format("DD/MM/YYYY");
  const examResultDate = resultDate ? moment(resultDate).format("DD/MM/YYYY") : "";

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Fetch all institute courses
  useEffect(() => {
    dispatch(getCourses());
  }, [dispatch]);

  // Add Exam
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate result date if exam is completed
    if (showResultSchedule && (!resultDate || !resultTime)) {
      message.warning("Please select result declaration date and time");
      return;
    }
    
    // Format times to HH:MM string format
    let formattedStartTime = "";
    let formattedEndTime = "";
    let formattedResultTime = "";

    if (startTime && startTime instanceof Date && !isNaN(startTime)) {
      formattedStartTime = moment(startTime).format("HH:mm");
    } else if (typeof startTime === "string" && startTime) {
      formattedStartTime = startTime;
    }

    if (endTime && endTime instanceof Date && !isNaN(endTime)) {
      formattedEndTime = moment(endTime).format("HH:mm");
    } else if (typeof endTime === "string" && endTime) {
      formattedEndTime = endTime;
    }
    
    if (resultTime && resultTime instanceof Date && !isNaN(resultTime)) {
      formattedResultTime = moment(resultTime).format("HH:mm");
    } else if (typeof resultTime === "string" && resultTime) {
      formattedResultTime = resultTime;
    }
    
    const addExam = {
      name,
      subject,
      class: examClass,
      duration,
      totalMarks,
      passingMarks,
      negativeMarking,
      startDate: examStartDate,
      endDate: examEndDate,
      startTime: formattedStartTime,
      endTime: formattedEndTime,
      publicExam,
      // Add result fields
      resultDate: showResultSchedule ? examResultDate : "",
      resultTime: showResultSchedule ? formattedResultTime : "",
    };

    console.log("Submitting Exam Data:", addExam);
    
    try {
      const { data } = await axios.post("api/v1/exam/add", addExam);
      if (data.success === true) {
        message.success(data.message);
        localStorage.setItem("id", JSON.stringify(data?.data?._id));
        // Clear form fields
        setName("");
        setSubject("");
        setExamClass("");
        setDuration("");
        setTotalMarks("");
        setPassingMarks("");
        setStartDate(null);
        setEndDate(null);
        setStartTime("");
        setEndTime("");
        setNegativeMarking("");
        setPublicExam("");
        setResultDate(null);
        setResultTime("");
        setShowResultSchedule(false);
        // Automatically switch to the correct tab after adding the exam
        setValue(1);
      } else {
        message.error(data?.message);
        console.error("Failed to add exam:", data);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Failed to add exam");
      console.error("Failed to add exam:", error);
    }
  };

  // Use The Navigate in Question List
  const localStorageId = JSON.parse(localStorage.getItem("id"));

  // check the question length
  const getAllQuestionLength = async () => {
    try {
      if (!localStorageId) {
        message.warning("No questions added yet. Please add questions first.");
        return { success: false, count: 0 };
      }
      const response = await axios.get(`/api/v1/exam/${localStorageId}`);
      const count = response?.data?.data?.questions?.length || 0;
      setQuestionCount(count);
      return { success: true, count };
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to fetch question count"
      );
      return { success: false, count: 0 };
    }
  };

  useEffect(() => {
    if (localStorageId) {
      getAllQuestionLength();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorageId]);

  const handleShowQuestionList = async () => {
    const { success, count } = await getAllQuestionLength();
    if (!success) {
      return;
    }
    if (count === 0) {
      message.warning("No questions added yet. Please add questions first.");
    } else {
      navigate(`/admin/edit/exam/${localStorageId}`);
    }
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            mb: 3,
            fontFamily: "Poppins, sans-serif",
            color: "#2C3E50",
            letterSpacing: "2.5px",
            lineHeight: 1.8,
          }}
        >
          Add Exams And Questions
        </Typography>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            mb: 5,
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <MUILink
            component={Link}
            to="/"
            sx={{ color: "inherit", textDecoration: "none" }}
          >
            Dashboard
          </MUILink>
          <MUILink
            component={Link}
            to="/admin/exams"
            sx={{ color: "inherit", textDecoration: "none" }}
          >
            Exams
          </MUILink>
          <Typography sx={{ color: "primary.main" }}>
            Add Exams And Questions
          </Typography>
        </Breadcrumbs>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Add Exam" {...TabPanel(0)} />
            <Tab label="Add Question" {...TabPanel(1)} />
          </Tabs>
        </Box>

        {/* Add Exams */}
        <CustomTabPanel value={value} index={0}>
          <Typography
            variant="h6"
            sx={{
              pb: 2,
              pt: 3,
              fontFamily: "Poppins, sans-serif",
              color: "#555",
              letterSpacing: "2.5px",
              lineHeight: 1.8,
            }}
          >
            Create a new Exam
          </Typography>
          <Container
            onSubmit={handleSubmit}
            component="form"
            className="form_style border-style"
            maxWidth
          >
            <Box sx={{ mb: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="public-exam-label">Public Exam</InputLabel>
                <Select
                  labelId="public-exam-label"
                  id="public-exam"
                  value={publicExam}
                  label="Public Exam"
                  required
                  onChange={(e) => setPublicExam(e.target.value)}
                >
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="name"
              label="Exam Name *"
              name="name"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Exam Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="subject"
              label="Subject *"
              name="subject"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="class"
              label="Class *"
              name="class"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Class"
              value={examClass}
              onChange={(e) => setExamClass(e.target.value)}
              required
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="duration"
              label="Duration (mins) *"
              name="duration"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Duration (mins)"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              required
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="totalMarks"
              label="Total Marks *"
              name="totalMarks"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Total Marks"
              value={totalMarks}
              onChange={(e) => setTotalMarks(e.target.value)}
              required
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="passingMarks"
              label="Passing Marks *"
              name="passingMarks"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Passing Marks"
              value={passingMarks}
              onChange={(e) => setPassingMarks(e.target.value)}
              required
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="negativeMarks"
              label="Negative Marks (optional)"
              name="negativeMarks"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Negative Marks (optional)"
              value={negativeMarking}
              onChange={(e) => setNegativeMarking(e.target.value)}
            />

            <Typography
              variant="h6"
              sx={{
                pb: 1,
                mt: -2,
                fontFamily: "Poppins, sans-serif",
                color: "#555",
                letterSpacing: "2.5px",
                lineHeight: 1.8,
                fontSize: "16px",
              }}
            >
              Configure Exam Schedule
            </Typography>
            
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "1fr 1fr",
                  md: "1fr 1fr 1fr 1fr",
                },
                gap: 2,
                width: "100%",
                mb: 3,
              }}
            >
               {/* Date Pickers */}
                            <Box sx={{ display: "flex", gap: "20px", marginBottom: "20px", flexWrap: "wrap" }}>
                            <Box sx={{ mb: 3 }}>
              <DatePicker
                showIcon
                toggleCalendarOnIconClick
                isClearable
                placeholderText="Start Date"
                selected={startDate}
                onChange={handleStartDateChange}
                minDate={new Date()}
                maxDate={endDate}
                required
              />
              </Box>
<Box sx={{ mb: 3 }}> 
              <DatePicker
                showIcon
                toggleCalendarOnIconClick
                isClearable
                placeholderText="End Date"
                selected={endDate}
                onChange={handleEndDateChange}
                minDate={startDate || new Date()}
                required
              />
</Box>
</Box>
 {/* Time Pickers */}
              <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
              <Box> 
              <TextField
                fullWidth
                type="time"
                label="Start Time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                required
                 sx={{ minWidth: "150px" }}
              />
</Box>
 <Box>
              <TextField
                fullWidth
                type="time"
                label="End Time"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                required
                 sx={{ minWidth: "150px" }}
              />
            </Box>
              </Box>
 </Box>
            {/* Result Schedule Section - Optional */}
            <Box sx={{ mt: 3, mb: 2 }}>
              <Button
                variant="outlined"
                onClick={() => setShowResultSchedule(!showResultSchedule)}
                sx={{
                  mb: 2,
                  textTransform: "none",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {showResultSchedule ? "Hide Result Schedule" : "+ Add Result Declaration Schedule (Optional)"}
              </Button>
            </Box>

            {showResultSchedule && (
              <>
                <Typography
                  variant="h6"
                  sx={{
                    pb: 1,
                    fontFamily: "Poppins, sans-serif",
                    color: "#555",
                    letterSpacing: "2.5px",
                    lineHeight: 1.8,
                    fontSize: "16px",
                  }}
                >
                  Configure Result Declaration Schedule
                </Typography>
                
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "1fr 1fr",
                    },
                    gap: 2,
                    width: "100%",
                    mb: 3,
                  }}
                >
                  <DatePicker
                    showIcon
                    toggleCalendarOnIconClick
                    isClearable
                    placeholderText="Result Declaration Date"
                    selected={resultDate}
                    onChange={handleResultDateChange}
                    minDate={endDate || new Date()}
                    required={showResultSchedule}
                  />
                  
                  <TextField
                    fullWidth
                    type="time"
                    label="Result Declaration Time"
                    value={resultTime}
                    onChange={(e) => setResultTime(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    required={showResultSchedule}
                  />
                </Box>
                
                <Alert severity="info" sx={{ mb: 2 }}>
                  <strong>Note:</strong> Result will be visible to students only after the specified result declaration date and time. Leave this empty if you want to show results immediately after exam completion.
                </Alert>
              </>
            )}

            <Button
              variant="contained"
              type="submit"
              color="primary"
              className="courses_desc"
              sx={{
                mt: 3,
                borderRadius: "5px",
                textTransform: "none",
                fontFamily: "Poppins, sans-serif",
                letterSpacing: ".1rem",
                color: "white",
              }}
            >
              Add Exam
            </Button>
          </Container>
        </CustomTabPanel>

        {/* Add Questions */}
        <CustomTabPanel value={value} index={1}>
          <Typography
            variant="h6"
            sx={{
              pb: 2,
              pt: 3,
              fontFamily: "Poppins, sans-serif",
              color: "#555",
              letterSpacing: "2.5px",
              lineHeight: 1.8,
            }}
          >
            Add Question
          </Typography>
          <AddQuestions
            vendor_Id={user?._id}
            institute_Id={user?.instituteId}
          />

          <Button
            variant="outlined"
            onClick={handleShowQuestionList}
            type="submit"
            className="courses_desc"
            sx={{
              mt: 3,
              borderRadius: "50px",
              textTransform: "none",
              fontFamily: "Poppins, sans-serif",
              letterSpacing: ".1rem",
            }}
          >
            Show Question List
          </Button>
        </CustomTabPanel>
      </Box>
    </>
  );
}